import { render } from "./Stories.vue?vue&type=template&id=5c3367ec&scoped=true"
import script from "./Stories.vue?vue&type=script&lang=js"
export * from "./Stories.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=5c3367ec&lang=scss&scoped=true"

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3367ec"]])

export default __exports__